type TrafficVariablesConfig = {
	enableWeekDayCorrection: boolean;
	allowUtcMidnightCrossingRanges: boolean;
	enableHandleDST: boolean;
};

export const trafficVariablesConfig: TrafficVariablesConfig = {
	enableWeekDayCorrection: true,
	allowUtcMidnightCrossingRanges: true,
	enableHandleDST: true
};
